import { prop } from 'ramda';
import axios from './request';

/**
 * @typedef Request
 * @property {string} ID
 * @property {string} NAME
 * @property {string} URL
 * @property {boolean} CAN_OPEN
 */

/**
 *
 * @param {string} serialNumber
 * @param {string?} exclude Request number which will be excluded
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<{ items: array, total: number }>}
 */
export default function getServiceRequestsBySerialNumber(serialNumber, exclude, config) {
	return axios.get('/api/Requests/getBySerial/', {
		...config,
		params: {
			serialNumber,
			name: exclude,
		},
	})
		.then(({ data }) => data)
		.then(prop('data'))
}
